<div [class]="showSuccessMsg ? 'verifyEmailContainer successBackground':'verifyEmailContainer errorBackground'">
    <div class="box" *ngIf="showSuccessMsg">
      <div class="alert-div">
        <mat-icon class="icon-alert">check_circle</mat-icon>
        <p class="content alert-text">
          {{ "VERIFICATION.SUCCESS" | translate }}
        </p>
        <button class="btn-succ">
          <span routerLink="/login"> {{ "VERIFICATION.CONTINUE" | translate }}</span>
        </button>
      </div>
    </div>
    <div class="box" *ngIf="!showSuccessMsg">
      <div class="alert-div">
        <mat-icon class="icon-alert-error">error</mat-icon>
        <p class="content alert-text">
          {{ "VERIFICATION.ERROR" | translate }}
        </p>
        <button class="btn-succ">
          <span routerLink="/index/login">{{ "VERIFICATION.TRY_AGAIN" | translate }}</span>
        </button>
      </div>
    </div>
</div>
